<template>
  <!-- ホルター心電図解析結果承認 -->
  <div id="HolterJudgment">
    <div id="container">
      <holterNavi pageid="HolterJudgment"/>
      <div class="labelTitle lable">ホルター心電図解析 判定依頼一覧</div>
      <!--検索条件 -->
      <div class="condition-area">
        <table class="conditionTable">
          <tr>
            <th>受付番号</th>
            <td><input
              v-model="searchConditions.receiptNumber"
              type="text"
              maxlength="20"></td>
            <th>種別</th>
            <td><select v-model="searchConditions.kind">
              <option/>
              <option value="401">ホルター心電図配送ｻｰﾋﾞｽ</option>
            </select></td>
            <th>デモ</th>
            <td><select v-model="searchConditions.demo">
              <option/>
              <option value="false">含まない</option>
              <option value="true">デモのみ</option>
            </select></td>
            <th>解析方法</th>
            <td><select v-model="searchConditions.analysisMethod">
              <option
                v-for="method in analysisMethodList"
                :value="method.value"
                :key="method.value">{{ method.label1 }}</option>
            </select></td>
          </tr>
          <tr>
            <th>解析オプション</th>
            <td><select
              v-model="searchConditions.analysisOption"
              name="解析オプション" >
              <option
                v-for="analysisOption in analysisOptionList"
                :value="analysisOption.value"
                :key="analysisOption.value">{{ analysisOption.label1 }}</option>
            </select>
            </td>
            <th>依頼元</th>
            <td><input
              v-model="searchConditions.client"
              type="text"
              maxlength="256"></td>
            <th>医療機関</th>
            <td><input
              v-model="searchConditions.hospital"
              type="text"
              maxlength="256"></td>
            <th>患者名</th>
            <td><input
              v-model="searchConditions.patientName"
              type="text"></td>
          </tr>
          <tr>
            
            
            <th>状態</th>
            <td><select v-model="searchConditions.status">
              <option :value="null"></option>
              <option value="1">判定依頼中</option>
              <option value="2">判定中</option>
              <option value="3">判定済み</option>
              <option value="10">ファイル差替中</option>
            </select></td>

            <th>解析期限</th>
            <td colspan="3"><input
              v-model="searchConditions.analysisDeadlineStart"
              type="date"> ～ <input
                v-model="searchConditions.analysisDeadlineEnd"
                type="date"></td>
          </tr>
        </table>
        <div class="searchButton-area">
          <b-button
            class="is-primary"
            @click="doSearch" >検索</b-button>
        </div>
      </div>
      <!-- 検索結果 -->
      <div
        v-if="hasResult"
        class="result-area" >
        <span class="result-count">件数：{{ data.length }}件</span>
        <b-table
          id="holterAnalysisResultTable"
          :data="data"
          :paginated="isPaginated"
          per-page="100"
          pagination-position="both"
          default-sort="analysisDeadline"
          default-sort-direction="asc"
          aria-next-label="Next page"
          aria-previous-label="Previous page"
          aria-page-label="Page"
          aria-current-label="Current page"
        >
          <template slot-scope="props">
            <b-table-column
              field="receiptNumber"
              label="受付番号"
              width="100"
              sortable
              centered>
              <router-link :to="{name:'HolterJudgmentDetail', params:{item:props.row, searchConditions:searchConditions}}"><a>{{ props.row.receiptNumber }}</a></router-link>
            </b-table-column>
            <b-table-column
              field="analysisDeadline"
              label="解析期限"
              width="120"
              sortable
              centered >
              {{ props.row.analysisDeadline }}
            </b-table-column>
            <b-table-column
              field="judgmentDocterAnalysisLimit"
              label="判定期限"
              width="120"
              sortable
              centered >
              {{ props.row.judgmentDocterAnalysisLimit }}
            </b-table-column>
            <b-table-column
              field="returnDeadline"
              label="返却希望日"
              width="110"
              sortable
              centered>
              {{ props.row.returnDeadline }}<span
                v-if="props.row.urgent"
                class="urgent" />
            </b-table-column>
            <b-table-column
              field="inspectionKind"
              label="種別"
              width="130"
              sortable>
              {{ props.row.inspectionKind }}<span
                v-if="props.row.demo"
                class="demo" /><span
                  v-if="props.row.depositMachineFlag"
                  class="depo"/>
            </b-table-column>
            <b-table-column
              v-if="props.row.inspectionKind=='ホルター心電図配送ｻｰﾋﾞｽ'"
              field="analysisMethod"
              label="解析方法"
              width="150"
              sortable>
              ホルター心電図
            </b-table-column>
            <b-table-column
              v-if="props.row.inspectionKind=='ホルター心電図解析ｻｰﾋﾞｽ'"
              field="analysisMethod"
              label="解析方法"
              width="150"
              sortable>
              {{ props.row.analysisMethod | getChoiceFilter(analysisMethodList) }}
            </b-table-column>
            <b-table-column
              label="解析オプション"
              field="analysisOption"
              width="150"
              sortable >
              {{ props.row.analysisOption | getChoiceFilter(analysisOptionList) }}
            </b-table-column>
            <b-table-column
              field="client"
              label="依頼元"
              width="250"
              sortable>
              {{ props.row.client }}
            </b-table-column>
            <b-table-column
              field="hospital"
              label="医療機関"
              width="250"
              sortable>
              {{ props.row.hospital }}
            </b-table-column>
            <b-table-column
              field="patientName"
              label="患者名"
              width="170"
              sortable>
              {{ props.row.patientName }}
            </b-table-column>
            <b-table-column
              v-if="props.row.cvhri!=-1"
              field="cvhri"
              label="CVHRI"
              width="75"
              sortable
              centered>
              {{ props.row.cvhri }}
            </b-table-column>
            <b-table-column
              v-if="props.row.cvhri==-1"
              field="cvhri"
              label="CVHRI"
              width="75"
              sortable
              centered>
              算出不可
            </b-table-column>
            <b-table-column
              v-if="!atLaunchHidden.hiddenFlag && props.row.afKind==0"
              field="af"
              label="AF"
              width="50"
              sortable
              centered/>
            <b-table-column
              v-if="props.row.af==1"
              field="af"
              label="AF"
              width="50"
              sortable
              centered>
              有
            </b-table-column>
            <b-table-column
              v-if="props.row.af==2"
              field="af"
              label="AF"
              width="50"
              sortable
              centered>
              無
            </b-table-column>
            <b-table-column
              field="judgmentResult"
              label="判定結果"
              width="120"
              sortable
              centered >
              {{ props.row.judgmentResult }}
            </b-table-column>
            <b-table-column
              field="analysisStaffName"
              width="110"
              label="解析実施者"
              sortable>
              {{ props.row.analysisStaffName }}
            </b-table-column>
            <b-table-column
              field="authorizer"
              width="110"
              label="承認者"
              sortable>
              {{ props.row.authorizer }}
            </b-table-column>
            <b-table-column
              field="judgmentDocterName"
              label="判定医"
              width="120"
              sortable
              centered >
              {{ props.row.judgmentDocterName }}
            </b-table-column>
            <b-table-column
              field="status"
              label="状態"
              width="80"
              centered
              sortable>
              <span
                :class="getTagClass4PSGApproval(props.row.status)"
                style="width:100px;">{{ props.row.status }}</span>
            </b-table-column>
          </template>
        </b-table>
      </div>
    </div>
  </div>
</template>

<script>
import naviBar from '@/components/mock/philips/holterAnalysis/HolterAnalysisNaviBar'
import {choicesType, atLaunchHidden} from '@/components/mock/base/const.js'

export default {
  name: 'HolterJudgment',
  filters: {
    getChoiceFilter (value, analysisMethodList) {
      const target = analysisMethodList.find(val => val.value === value)
      if (target) {
        return target.label1
      }
      return ''
    }
  },
  components: {
    holterNavi: naviBar
  },
  data () {
    const takeOverSearchParams = this.$route.params['searchConditions']
    const defaultDate = this.getDate()
    return {
      searchConditions: {
        receiptNumber: '',
        kind: '',
        demo: '',
        analysisMethod: '',
        analysisOptionList: '',
        client: '',
        hospital: '',
        patientName: '',
        status: '1',
        analysisDeadlineStart: defaultDate,
        analysisDeadlineEnd: defaultDate,
        returnDeadlineStart: '',
        returnDeadlineEnd: ''
      },
      choicesType: choicesType,
      data: [],
      isPaginated: true,
      analysisMethodList: [],
      analysisOptionList: [],
      takeOverSearchParams,
      hasResult: false,
      atLaunchHidden: atLaunchHidden
    }
  },
  async mounted () {
    // マスタ取得
    await this.getChoicesList()
    if (this.takeOverSearchParams) {
      this.searchConditions = this.takeOverSearchParams
      this.doSearch()
    }
  },
  methods: {
    doSearch: function () {
      let isSearchParam = false
      const keys = Object.keys(this.searchConditions)
      for (let i = 0; i < keys.length; i++) {
        if (this.searchConditions[keys[i]]) {
          isSearchParam = true
          break
        }
      }
      if (!isSearchParam) {
        // 検索条件が１つも設定されていない場合
        this.showErrorMessage('検索条件が入力されていません。')
        return
      }
      if(!this.searchConditions.status) this.searchConditions.status = "11"
      this.data = []
      this.hasResult = false
      const excuteApi = this.getHolterAnalysisResultApprovalListPOST
      const successCallBack = this.getHolterAnalysisResultApprovalListPOSTSuccess
      const errorCallBack = this.getHolterAnalysisResultApprovalListPOSTError
      // Web Api Call
      this.apiCall(excuteApi, successCallBack, errorCallBack)
    },
    getHolterAnalysisResultApprovalListPOST: function (client) {
      const obj = JSON.parse(JSON.stringify(this.searchConditions))
      return client.apis.apiCommon.getHolterJudgmentListPOST({
        body: obj
      })
    },
    getHolterAnalysisResultApprovalListPOSTSuccess: function (result) {
      // 検索結果取得
      this.data = result.obj
      this.hasResult = true
      if(this.searchConditions.status == "11") this.searchConditions.status = null
    },
    getHolterAnalysisResultApprovalListPOSTError: function (result) {
      // エラーメッセージ表示
      this.showErrorMessage(result)
    },
    getChoicesList: async function () {
      this.analysisMethodList = this.getChoiceList(this.choicesType.holterMethod, false)
      this.analysisOptionList = this.getChoiceList(this.choicesType.holterAnalysisOp, false)
      this.analysisMethodList.unshift({})
      this.analysisOptionList.unshift({})
    },
    // 当日日付を計算
    getDate () {
      return this.yyyy_hyp_MM_hyp_dd(new Date())
    }
  }
}
</script>
<style lang="scss" scoped>
a {
  text-decoration: underline;
}
.tag {
  width: 80px;
}
input {
  width: 200px;
}
</style>



// WEBPACK FOOTER //
// src/components/mock/philips/holterAnalysis/HolterJudgment.vue